<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div class="loading-indicator" role="status">
    <div class="loading-indicator__spinner">
      <Overlay
        :show="true"
        :circleColor="'#40a4c6'"
        :borderColor="'#40a4c6'"
      />
    </div>
    <span class="loading-indicator__text">
      {{ t('global.cargando') }}
      <span class="loading-indicator__dots"><i /><i /><i /></span>
    </span>
  </div>
</template>

<style scoped lang="scss">
$blue: #40a4c6;
$pink: #ff436f;

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  animation: pop-in 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);

  &__spinner {
    position: relative;
    width: 84px;
    height: 65px;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 96px;
      height: 96px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba($blue, 0.22) 0%, rgba($blue, 0) 70%);
      transform: translate(-50%, -50%);
      animation: halo 1.8s ease-in-out infinite;
    }

    :deep(.b-overlay-wrap) {
      position: absolute !important;
      top: 0;
      left: 0;
      width: 96px;
      height: 0;
      transform: scale(0.875);
      transform-origin: top left;
    }
  }

  &__text {
    display: inline-flex;
    align-items: baseline;
    gap: 0.15rem;
    font-size: 0.85rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: $blue;
  }

  &__dots {
    display: inline-flex;
    gap: 3px;

    i {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: $pink;
      animation: dot 1.2s ease-in-out infinite;

      &:nth-child(2) {
        animation-delay: 0.15s;
      }

      &:nth-child(3) {
        animation-delay: 0.3s;
      }
    }
  }
}

@keyframes pop-in {
  from {
    transform: translateY(8px) scale(0.96);
  }
  to {
    transform: none;
  }
}

@keyframes halo {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(0.85);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 1;
  }
}

@keyframes dot {
  0%,
  80%,
  100% {
    transform: translateY(0);
    opacity: 0.35;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-indicator,
  .loading-indicator__spinner::before,
  .loading-indicator__dots i {
    animation: none;
  }
}
</style>
